import { numberMoney } from 'Data/format.js'

export function getValue(payment_plan) {
  let amount = payment_plan.discounts.reduce(
    (acc, discount) => acc + discount.amount,
    0
  )
  return `(${payment_plan.discounts.length}) - ${numberMoney(amount)}`
}
